import { FC } from 'react'

const SkeletonCards: FC<{ numberOfCards?: number }> = ({
  numberOfCards = 12,
}) => {
  return (
    <>
      {Array.from({ length: numberOfCards }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </>
  )
}

const SkeletonCard = () => {
  return (
    <div className="border shadow rounded-xl w-full mx-auto">
      <div className="animate-pulse flex flex-col">
        <div className="h-48 md:h-40 xl:h-48 w-full bg-slate-200" />
        <div className="w-full p-4 flex flex-col gap-1">
          <div className="h-6 w-5/6 bg-slate-200 rounded" />
          <div className="h-6 w-1/3 bg-slate-200 rounded" />
          <div className="h-2 w-4/5 bg-slate-200 rounded" />
          <div className="h-4 w-3/5 bg-slate-200 rounded" />
          <div className="h-5 w-1/3 mt-3 mb-4 bg-slate-200 rounded" />
          <div className="h-4 bg-slate-200 rounded" />
          <div className="h-2 bg-slate-200 rounded" />
        </div>
      </div>
    </div>
  )
}

export default SkeletonCards
